import React from 'react';
import na1 from '../media/os1.jpg';
import na2 from '../media/os2.jpg';
import na3 from '../media/os3.jpg';
import na4 from '../media/os4.jpeg';
import { Link } from 'react-router-dom';

export default function OurServices() {
    const services = [
        {
            image: na1,
            title: 'Bathrobe'
        },
        {
            image: na2,
            title: 'Personalized Stuffed Toy'
        },
        {
            image: na3,
            title: 'Diaper Changing Mats'
        },
        {
            image: na4,
            title: 'Cotton Knitted Blankets'
        }
    ]
    return (
        <div className="container" style={{}}>
            <div className='ourservices row' style={{ paddingBottom: '95px' }}>
                <p className='text-center' style={{ marginBottom: '75px', fontSize: '30px', fontWeight: '500', color: '#5f5b57' }}>Our Services</p>

                {services.map((service, idx) => (
                    <div key={idx} className="col-lg-3 col-md-3 col-sm-6 col-xs-6 column">
                        <img src={service.image} alt={`Service ${idx + 1}`} />
                        <p className='text-center content'>
                            <Link to='/collection/all'>{service.title}</Link>
                        </p>
                        {/* <div className='text-center'>
                            <Link to='' className='btn-cart welcome-add-cart text-center'>Order Now</Link>
                        </div> */}
                    </div>
                ))}
            </div>
        </div>
    );
}
